module.exports = __webpack_public_path__ + "static/media/arm.df5e23ed.png";